import React from 'react';
import styled from 'styled-components';
import WheelComponent from '../../components/WheelComponent';
import * as Styled from './styles';

const ModalOverlay = styled.div`
  position: fixed;
  top: -200vw;
// top:0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  z-index: 9999;
`;

const ModalContent = styled.div`
  position: relative;
  width: 800px;
  height: 800px;
  background: ${props => props.segmentBgColor};
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

const WheelContainer = styled.div`
  width: 600px;
  height: 600px;
  position: relative;
  z-index: 1;
`;

const WallpaperWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
`;

function ScreenshotModal({
    isOpen,
    onClose,
    segmentBgColor,
    currentBg,
    base64Wallpaper,
    wallpaperTransparency,
    chartData,
    userData
}) {
    const updatedChartData = chartData.map(item => ({
        ...item,
        selected: false
    }));
    if (!isOpen) return null;
    console.log(currentBg, "curren0101011tBg", base64Wallpaper, "base64Wallpaper");
    return (
        <ModalOverlay>
            <ModalContent className="modal-content" segmentBgColor={segmentBgColor}>
                <WallpaperWrapper>
                    {(currentBg === 2 || currentBg === 3) && base64Wallpaper && (
                        <Styled.WheelWallpaperImage
                            currentBg={currentBg}
                            bgWallpaper={base64Wallpaper}
                            wallpaperTransparency={wallpaperTransparency}
                        />
                    )}
                </WallpaperWrapper>
                {/* <WheelContainer> */}
                <WheelComponent
                    width="250px"
                    height="250px"
                    chartData={updatedChartData}
                    margin={20}
                    showLabels={false}
                    config={{
                        isNotDraggable: true,
                        segmentHighlighting: false,
                    }}
                    userData={userData}
                />
                {/* </WheelContainer> */}
            </ModalContent>
        </ModalOverlay>
    );
}

export default ScreenshotModal;